import React, {Component} from "react";

export default class InputMaterial extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className="row mt-3">
                <div className="col s12">
                    <div className="input-tutor">
                        {this.props.disabled &&<div className="disable-input">
                            <span>Not editable</span>
                        </div>}
                        {!this.props.multiLine && <input id={this.props.id}
                                placeholder={this.props.title}
                                onChange={this.props.onChange}
                                value={this.props.value}
                                type={this.props.type}
                                ref={this.props.id}
                                className={this.props.valid === undefined ? "" : (this.props.valid ? "validate" : "invalid")}/>
                        }
                        {this.props.multiLine && <textarea id={this.props.id}
                                placeholder={this.props.title}
                                onChange={this.props.onChange}
                                value={this.props.value}
                                ref={this.props.id}
                                className={this.props.valid === undefined ? "" : (this.props.valid ? "validate" : "invalid")}/>
                        }
                        <span className="helper-text" data-error={this.props.wrongMsg} data-success={this.props.successMsg} />
                    </div>
                </div>
            </div>
        );
    }
}
